import { useAppSelector, useAppDispatch } from 'Store/selectors'
import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { getDraftVisitItem, getVisitItem } from '../../Actions/action'
import VisitMainData from './VisitMainData'
import VisitOtherData from './VisitOtherData'
import FileDownloader from 'Components/FileDownloader'
import VisitsApiPaths from 'Application/Visits/Constants/VisitsApiPaths'
import { useTranslation } from 'react-i18next'
import VisitsPaths from 'Application/Visits/Constants/VisitsPaths'
import CircularProgressbar from 'Components/CircularProgressbar'
import StartVisitButton from './StartVisitButton'
import Icon from 'Components/Icon'
import { VisitsTabsEnum } from 'Application/Visits/Actions/enums'

const VisitPage = () => {
  const [t] = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { visitId } = useParams<{ visitId: string }>()
  const tabValue: VisitsTabsEnum = Number(searchParams.get('tabValue'))

  const { visitItem, draftVisitItem } = useAppSelector(store => ({
    visitItem: store.visits.visitItem,
    draftVisitItem: store.visits.draftVisitItem,
  }))

  const isVisitsTab = tabValue === VisitsTabsEnum.Visits
  const isDraftsTab = tabValue === VisitsTabsEnum.Drafts

  const data = isVisitsTab ? visitItem.data : draftVisitItem.data
  const loading = visitItem.loading || draftVisitItem.loading

  useEffect(() => {
    if (isVisitsTab) {
      dispatch(getVisitItem(visitId))
      return
    }
    if (isDraftsTab) {
      dispatch(getDraftVisitItem(visitId))
      return
    }
  }, [visitId, tabValue])

  if (loading) {
    return (
      <div className="flex items-center justify-center grow">
        <CircularProgressbar />
      </div>
    )
  }

  return (
    <>
      <div className="flex justify-between items-center h-16 px-6 shrink-0">
        <div className="flex items-center gap-2">
          <div onClick={() => navigate(-1)}>
            <Icon name="arrow-right" className="w-6 h-6 text-gray-700" />
          </div>
          <div className="text-lg font-bold pl-2">{t('VISIT_DETAIL')}</div>
        </div>
      </div>

      {data && (
        <>
          <div className="flex flex-col grow overflow-auto">
            <div className="overflow-auto px-6 pb-6">
              <VisitMainData data={data} />
              <VisitOtherData data={data} />
            </div>
          </div>

          <div className="cta">
            {draftVisitItem.data?.draftVisitId && isDraftsTab ? (
              <StartVisitButton draftVisit={draftVisitItem.data} />
            ) : (
              <FileDownloader
                url={`${VisitsApiPaths.GetVisitSummaryReportPdfFile}${visitItem.data?.id}`}
                title={t('VISIT_FILE')}
                fileName="VisitFile.pdf"
              />
            )}
          </div>
        </>
      )}
    </>
  )
}

export default VisitPage
